export const textFieldUtils = {
  inputPositiveNumber: {
    type: 'number',
    min: '0',
  },
};
